import React from "react";
import { bool } from "prop-types";
/* eslint-disable object-shorthand */
import { createDfpAdComponent } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";
// import get from "lodash/get";

// const ViewPortSizeMappingHorizontal728to320 = [
//   { viewport: [980, 90], sizes: [[728, 90]] },
//   { viewport: [320, 0], sizes: [[320, 50]] },
//   { viewport: [0, 0], sizes: [[320, 50]] }
// ];

// const ViewPortSizeMappingVertical600to250 = [
//   { viewport: [980, 90], sizes: [[300, 600]] },
//   { viewport: [320, 0], sizes: [[300, 250]] },
//   { viewport: [0, 0], sizes: [[300, 250]] }
// ];

const CONFIG = {
  NH_HP_728x90: {
    adUnit: ""
  },
  NH_300x600: {
    adUnit: ""
  },
  NH_300x250: { adUnit: "" },
  NH_MP_300x600: { adUnit: "" },

  Election_NH_HP_728x90: {
    adUnit: ""
  },

  Election_NH_HP_320X50: {
    adUnit: ""
  },

  Election_NH_HP_300X250: {
    adUnit: ""
  }
};

const DfpAdContent = createDfpAdComponent({
  defaultNetworkID: "21687414328",
  config: CONFIG,
  targeting: function(state) {
    const params = {};
    return params;
  },
  disableInitialLoad: true,
  singleRequest: true
});

const DfpAdView = function(props) {
  if (props.isActivePlan) return null;

  return (
    <div>
      <DfpAdContent {...props} />
    </div>
  );
};

DfpAdView.propTypes = {
  isActivePlan: bool
};

function mapStateToProps(state) {
  return {
    isActivePlan: get(state, ["userReducer", "isActivePlan"], false)
  };
}

export const DfpAd = connect(
  mapStateToProps,
  null
)(DfpAdView);
